<template>
    <div class="centered-page">
        <div class="contact">
            <div class="header-row">
                <div class="title">Contact</div>
            </div>
            <div class="contacts">
                <a href="mailto:calsappdev@gmail.com" class="pill-button">
                    <img src="../assets/email.png" class="contact-icon"><span>Email</span>
                </a>
                <a href="https://youtube.com/@CodeWithCal" class="pill-button">
                    <img src="../assets/youtube.png" class="contact-icon"><span>Youtube</span>
                </a>
                <a href="https://github.com/codeWithCal" class="pill-button">
                    <img src="../assets/git-hub.png" class="contact-icon"><span>Github</span>
                </a>
                <a href="https://play.google.com/store/apps/developer?id=Callum+Hill" class="pill-button">
                    <img src="../assets/play-store.png" class="contact-icon"><span>Play Store</span>
                </a>
                <a href="https://apps.apple.com/au/developer/callum-hill/id1130167139" class="pill-button">
                    <img src="../assets/app-store.png" class="contact-icon"><span>App Store</span>
                </a>
                <a href="https://twitter.com/callumcah" class="pill-button">
                    <img src="../assets/twitter.png" class="contact-icon"><span>X (Twitter)</span>
                </a>
            </div> 
        </div>
    </div>
</template>

<style >

.contact
{
    display: flex;
    row-gap: 3rem;
    max-width: 800px;
}

.contacts
{
    display: flex;
    column-gap: 2rem;
    flex-wrap: wrap;
    align-content: center;
    row-gap: 2rem;
    justify-content: center;
    padding-bottom: 4rem;
}

.contact .pill-button
{
    min-width: 140px;
    justify-content: space-between;
    align-items: center;
}

.contact .pill-button .contact-icon
{
    max-height: 35px;
    max-width: 35px;
}

.contact .header-row
{
    width: 100%;
}

.contact .title
{
    font-weight: bold;
    font-size: 30px;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
}
</style>